import React, { useEffect } from "react";
import { Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Form, Formik } from "formik";
import { Button } from "@thrivetribe/gloji.ui.atoms.button";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import {
  ModalPageHeader,
  ModalPageBody,
  ModalPageFooter,
  ModalPageWrapper,
  ModalPageHeading,
} from "../../../organisms/ModalPage";
import RadioButtonGroup from "../../../molecules/RadioButtonGroup/RadioButtonGroup";
import { update_signup_form_values } from "../../../../store/actions/signupFlowData";
import { PhysicalHealthValidationSchema } from "../../../../data/Validation/EligibilityCheckerValidation";
import FormikCheckbox from "../../../atoms/FormikCheckbox";
import CheckboxGroupContainer from "../../../atoms/CheckboxGroupContainer";
import { physicalHealthConditions } from "../../../../enums/profile/PhysicalHealthCondition";

const PhysicalHealth = () => {
  const dispatch = useDispatch();
  const signupFormValues = useSelector((state) => state.signupFlowData.signupFormValues);
  const physicalHealthData = useSelector(
    (state) => state.signupFlowData.signupPagesData["physical-health"]
  );

  let history = useHistory();

  const initialValues = {
    physicalHealth: signupFormValues?.physicalHealth ?? "",
    physicalConditions: signupFormValues?.physicalConditions ?? [],
  };

  const yesNoOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];

  useEffect(() => {
    window.gtag("event", "page_view", {
      page_title: "Physical health | Eligibility checker | Sign up | Gloji",
    });
  }, []);

  const handleSubmit = (values) => {
    if (values.physicalHealth === "no") {
      // Save values to store
      dispatch(update_signup_form_values({ ...values, physicalConditions: [] }));
    } else {
      // Save values to store
      dispatch(update_signup_form_values(values));
    }
    history.push(`/mental-health`);
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={PhysicalHealthValidationSchema}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ isSubmitting, values, touched, errors }) => (
          <Form className="eligibility-checker-form physical-health-form">
            <Helmet>
              <title>Physical health | Eligibility checker | Sign up | Gloji</title>
            </Helmet>
            <ModalPageWrapper>
              <ModalPageBody className="with-sticky-footer">
                <ModalPageHeader
                  backButtonOnClick={() => {
                    history.goBack();
                  }}
                >
                  Checking we're a good fit
                </ModalPageHeader>

                <ModalPageHeading>{physicalHealthData?.questions[0].question}</ModalPageHeading>
                <RadioButtonGroup
                  options={yesNoOptions}
                  name="physicalHealth"
                  hasErrors={errors[`physicalHealth`] && touched["physicalHealth"]}
                />
                <Accordion square={true} elevation={0} className="eligibility-checker__accrodion">
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon fontSize="large" />}
                    aria-controls={`physical-question-explanation`}
                  >
                    <span>{physicalHealthData?.questions[0].whyQuestion}</span>
                  </AccordionSummary>
                  <AccordionDetails>
                    <span>{physicalHealthData?.questions[0].whyQuestionDetails}</span>
                  </AccordionDetails>
                </Accordion>

                {values.physicalHealth === "yes" && (
                  <>
                    <ModalPageHeading>Select any that apply to you</ModalPageHeading>
                    <CheckboxGroupContainer name="physicalConditions">
                      {physicalHealthConditions.map((item) => (
                        <FormikCheckbox
                          key={item.value}
                          id={item.value}
                          name="physicalConditions"
                          label={item.label}
                          value={item.value}
                        />
                      ))}
                    </CheckboxGroupContainer>
                  </>
                )}
              </ModalPageBody>
              <ModalPageFooter className="sticky-footer">
                <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
                  Continue
                </Button>
              </ModalPageFooter>
            </ModalPageWrapper>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default PhysicalHealth;
